const MENU_CURATION_TASK_SORT_BY = {
  DEFAULT: {
    label: 'Default',
    value: 'DEFAULT',
  },
  QA: {
    label: 'Qa',
    value: 'QA',
  },
  QC: {
    label: 'Qc',
    value: 'QC',
  },
  AUTOEAT_UPDATED_AT: {
    label: 'Autoeat Updated At',
    value: 'AUTOEAT_UPDATED_AT',
  },
}

export default MENU_CURATION_TASK_SORT_BY
